import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InputRadio from '../input-radio';
import styles from './radio-list.scss';

class RadioList extends Component {
  render() {
    const { id, options, isDisabled, onChange } = this.props;
    return (
      <div
        id={id}
        className={classNames(styles.radioGroup, 'forum-card-border-color')}
        role="radiogroup"
      >
        {options.map(({ value, label, isIndented }, i) => (
          <div
            key={i}
            style={{ paddingLeft: isIndented ? '12px' : 'auto' }}
            className={classNames(styles.option, 'forum-card-border-color')}
          >
            <InputRadio
              name={name}
              value={value}
              onChange={() => onChange(value)}
              checked={value === this.props.value}
              text={label}
              tabIndex={String(i - 1)}
              disabled={isDisabled}
            />
          </div>
        ))}
      </div>
    );
  }
}

RadioList.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array,
  isDisabled: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default RadioList;
